import getRequest from "@/interface/index";
import i18n from "./i18n";

const initMenu = (router, store) => {
  if (store.state.menuList.length > 0) {
    return false;
  }
  getRequest.request("system/listForMenu", "GET").then(res => {
    if (res && res.code === 0) {
      if (res.data && res.data.menu && res.data.menu.length > 0) {
        store.dispatch("initMenuList", res.data);
        const fmRoutes = formatRoutes(res.data.menu);
        router.addRoutes(fmRoutes);
      } else {
        // 没有菜单则跳转到登录页
        this.$router.push("/login");
      }
    }
  });
};

let fmRoutes = [
  {
    path: "/main",
    name: i18n.t("route.main"),
    component: resolve => require(["@/views/Index.vue"], resolve),
    meta: { title: i18n.t("route.main"), auth: true, keepAlive: true },
    children: [
      {
        path: "/main",
        name: i18n.t("route.index"),
        component: resolve => require(["@/views/Main.vue"], resolve),
        meta: {
          title: i18n.t("route.index"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/user/info",
        name: i18n.t("route.userInfo"),
        component: resolve => require(["@/views/other/UserInfo.vue"], resolve),
        meta: {
          title: i18n.t("route.userInfo"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/dictionary-data/:codesId/:dictType",
        name: i18n.t("route.dictData"),
        component: resolve => require(["@/views/system/DictionaryData.vue"], resolve),
        meta: {
          title: i18n.t("route.dictData"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/myapps/adver/desktop",
        name: i18n.t("myApps.ggtf"),
        component: resolve => require(["@/views/myapps/adver/Desktop"], resolve),
        meta: {
          title: i18n.t("myApps.ggtf"),
          auth: true,
          keepAlive: true
        }
      },

      {
        path: "/myapps/theme/list",
        name: i18n.t("theme.title"),
        component: resolve => require(["@/views/myapps/theme/list"], resolve),
        meta: {
          title: i18n.t("theme.title"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/upgrade/list/applist",
        name: i18n.t("upgrade.appList"),
        component: resolve => require(["@/views/upgrade/list/applist"], resolve),
        meta: {
          title: i18n.t("upgrade.appList"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/upgrade/apk",
        name: i18n.t("upgrade.apkList"),
        component: resolve => require(["@/views/upgrade/Apk"], resolve),
        meta: {
          title: i18n.t("upgrade.appList"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/myapps/payment/index",
        name: i18n.t("myApps.shoukuantitle"),
        component: resolve => require(["@/views/myapps/payment/index"], resolve),
        meta: {
          title: i18n.t("myApps.shoukuantitle"),
          auth: true,
          keepAlive: true
        }
      },
      {
        path: "/statistics/wti-dashboard",
        name: "WTI Dashboard",
        component: resolve => require(["@/views/statistics/WtiDashboard.vue"], resolve),
        meta: {
          title: "WTI Dashboard",
          auth: true,
          keepAlive: false
        }
      },
      // 运营者专属批发优惠（前端静态路由：后端菜单无此页）
      {
        path: "/perks",
        name: "Perks",
        component: resolve => require(["@/views/perks/Perks.vue"], resolve),
        meta: {
          title: "Perks",
          auth: true,
          keepAlive: true
        }
      },
      // 审计日志枢纽（前端静态路由：汇总充值/钱包/库存/在线状态等旧页面）
      {
        path: "/logs",
        name: "AuditLogs",
        component: resolve => require(["@/views/logs/AuditLogs.vue"], resolve),
        meta: {
          title: "Audit logs",
          auth: true,
          keepAlive: true
        }
      }
    ]
  }
];

const formatRoutes = routes => {
  if (routes && routes.length > 0) {
    for (let i = 0; i < routes.length; i++) {
      setRoutes(routes[i]);
    }
  }
  return fmRoutes;
};

const routers = route => {
  return {
    path: route.path + "/" + url(route.component),
    component: resolve => require(["@/views" + route.path + "/" + route.component + ".vue"], resolve),
    name: route.name,
    icon: route.icon,
    meta: route.meta,
    children: route.children
  };
};

const setRoutes = routes => {
  let children = routes.children;
  if (children && children.length > 0) {
    for (let i = 0; i < children.length; i++) {
      let child = children[i];
      if (child && child.component) {
        fmRoutes[0].children.push(routers(child));
      }
      if (child && child.children) {
        setRoutes(child);
      }
    }
  } else {
    fmRoutes[0].children.push(routers(routes));
  }
};

const url = component => {
  if (component) {
    component = component.replace(component[0], component[0].toLowerCase());
    return component.replace(/([A-Z])/g, "-$1").toLowerCase();
  }
};

export default {
  initMenu,
  formatRoutes
};
